import React, { memo, useContext } from 'react';
import { PairOfCardsV2 } from '../../../../components/PairOfCardsV2/PairOfCardsV2';
import CashSvg from '../Svg/CashSvg';
import TournamentSvg from '../Svg/TournamentSvg';
import { getMediaUrl } from '../../../../utils/utils';
import StandartIcon from '../../../../icons/standart.svg';
import PremiumIcon from '../../../../icons/premium.svg';
import './QuizCard.scss';
import { AppContext } from '../../../../AppContext';
import Countdown from "react-countdown";
import BrowserLink from '../../../../components/BrowserLink';

export const QuizCard = memo(function Card({
  data: { img, coach_bg, imgAlt, title, text, cards, link, access, locked, freemium },
  ...props
}) {
  const { user } = useContext(AppContext);
  const currentDate = new Date();

  const isNeedCountdown = user.type !== 'pcp' && freemium?.activate && currentDate > new Date(freemium.freemium_period_start) && currentDate < new Date(freemium.freemium_period_end);

  return (
    <BrowserLink href={link} className="QuizCard" {...props}>
      <div style={{position: 'relative'}}>
        <div className="QuizCard__image-block">
          <img src={coach_bg} alt={imgAlt} />
        </div>
        <div className="QuizCard__top-row">
          <PairOfCardsV2 cards={cards} className="QuizCard__cards" />
          <div className="QuizCard__pos">
            <span>{text.pos}</span>
          </div>
        </div>
        <div className="QuizCard__type">
          {text.type === 'cash' ? <CashSvg /> : <TournamentSvg />}
        </div>
        <div className="QuizCard__text">{text.stack}</div>
        <div className="QuizCard__subs-icons">
          {access === 'pc' ? (
            <>
              <img src={getMediaUrl(StandartIcon)} alt="" />
              <img src={getMediaUrl(PremiumIcon)} alt="" />
            </>
          ) : access === 'pcp' ? (
            <img src={getMediaUrl(PremiumIcon)} alt="" />
          ) : (
            isNeedCountdown ? <Countdown className="access__label access__countdown" date={new Date(freemium.freemium_period_end)} />  : <span>{access}</span>
            
          )}
        </div>
      </div>
    </BrowserLink>
  );
});
